import { COOKIES_AUTH_ACCESS_KEY, COOKIES_AUTH_USER } from 'hooks/use-auth';
import { getCookies } from 'utils/cookies';
import axios from 'axios';
import _ from 'lodash';

export const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

instance.interceptors.request.use((config) => {
  const cookies = getCookies();
  config.headers['Accept'] = 'application/json, text/plain';
  if (!cookies[COOKIES_AUTH_ACCESS_KEY] || !cookies[COOKIES_AUTH_USER]) return config;
  config.headers.Authorization = 'Bearer ' + cookies[COOKIES_AUTH_ACCESS_KEY];
  return config;
});
